export default __webpack_public_path__ + "static/media/App.e013c7a8.less";